import { Directive, HostBinding, Input } from '@angular/core';

import { A11yBooleanInput } from '../interfaces/a11y.interfaces';
import { toBoolean } from '../utils/a11y.util';

@Directive({
  selector: '[khA11yCurrentPage]'
})
export class A11yCurrentPageDirective {
  @Input('khA11yCurrentPage') public isCurrent: A11yBooleanInput = false;

  @HostBinding('attr.aria-current')
  public get ariaCurrent(): 'page' | null {
    return toBoolean(this.isCurrent, true) ? 'page' : null;
  }
}
